<template>
    <div class="animated fadeIn equipmentList bgV2">
        <gofix-tab
                class="mt-3 contractPropertyTab"
                :variableWidth="true"
                :data="tabData"
                :query-param="queryParam"
                :activeKey="activeKey"
                @load-tab="loadTab">
            <template slot="gofixTab:right">
                <gofix-button
                    v-if="tabData[0].active"
                    @click="updateItemQuestion"
                    label="SAVE"
                    :disabled="$disabledCreateOrUpdate(this.sorItem, $accessModule.maintenance_program)"></gofix-button>
                <gofix-button
                        v-if="tabData[1].active"
                        outline
                        @click="modalsRunsheet"
                        label="Update Joblist"
                        :loading="disabledJob"
                        :disabled="!$checkRole($accessModule.client_contract_program, 'create')"></gofix-button>
            </template>
            <template slot="gofixTab:basic_info">
                <b-form class="formV2">
                    <gofix-card classContent="mb-0 mt-4">
                        <b-row>
                            <b-col md="2">
                                <gofix-form-input label="Code" v-model="sorItem.sor_code" required></gofix-form-input>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input label="Abbreviation" v-model="sorItem.abbreviation"></gofix-form-input>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input label="Description" v-model="sorItem.description_one"></gofix-form-input>
                            </b-col>
                        </b-row>
                    </gofix-card>

                    <gofix-card classContent="mb-0 mt-4">
                        <b-row>
                            <b-col md="4">
                                <gofix-form-tree
                                        label="Service Category"
                                        :multiple="false"
                                        :options="Services"
                                        :load-options="loadOptionsService"
                                        search-nested
                                        :normalizer="normalizerService"
                                        valueFormat="object"
                                        v-model="sorItem.service_category"
                                        placeholder=""
                                        required>
                                </gofix-form-tree>
                            </b-col>
                            <b-col md="4">
                                <gofix-form-tree
                                        label="Equipment Group"
                                        :multiple="false"
                                        :options="treeEquips"
                                        :load-options="loadOptionsEquiment"
                                        :normalizer="normalizerEquipment"
                                        search-nested
                                        valueFormat="object"
                                        v-model="sorItem.equipment_structure_type"
                                        placeholder="Select"
                                        ref="equipmentTree">
                                </gofix-form-tree>
                            </b-col>
<!--                            <b-col md="4">-->
<!--                                <div class="d-flex">-->
<!--                                    <b-form-checkbox v-model="sorItem.is_allow_editing_of_follow_up_after_job_completion" class="checkbox-main-allow"><span class="ml-2">Allow editing of follow-up after job completion</span></b-form-checkbox>-->
<!--                                </div>-->
<!--                            </b-col>-->
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_fm_officer_to_do_expired_jobs" class="checkbox-main-allow"><span class="ml-2">Allow FM Officer to do expired jobs</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <gofix-form-properties
                                        valueFormat="object"
                                        label="Property"
                                        :contract-id="$route.params.id"
                                        required
                                        v-model="sorItem.location_info">
                                </gofix-form-properties>
                            </b-col>
                            <b-col md="4">
                                <div class="d-flex maintCreateFrequency">
                                    <gofix-form-dropdown
                                            label="Checklist template"
                                            vLabel="name_checklist_templates"
                                            :clearable="false"
                                            :filterable="false"
                                            :required="true"
                                            :reduce="option => option.id"
                                            :append-to-body="true"
                                            v-model="sorItem.checklist_template_id"
                                            :options="checklistTemplates"
                                    >
                                    </gofix-form-dropdown>
                                    <gofix-button class="ml-3 text-left" label="Create New Checklist" @click="modals.checklist = true" noBorder fontNormal small></gofix-button>
                                </div>
                            </b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.checklist_mandatory_complete" class="checkbox-main-allow"><span class="ml-2">Checklist mandatory complete</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <gofix-form-input label="Standard Reference" v-model="sorItem.standard_reference"></gofix-form-input>
                            </b-col>
                            <b-col md="4">
                                <gofix-form-input label="Remarks" v-model="sorItem.remarks"></gofix-form-input>
                            </b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_fm_officer_verify_job" class="checkbox-main-allow"><span class="ml-2">Allow FM Officer to self-verify his completed job</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <div class="d-flex maintCreateFrequency">
                                    <gofix-form-dropdown
                                            label="Frequency"
                                            vLabel="recurring_mode"
                                            :clearable="false"
                                            :filterable="false"
                                            :required="true"
                                            :reduce="option => option.id"
                                            v-model="sorItem.sor_recurring_mode_id"
                                            :append-to-body="true"
                                            :options="sorRecurringModes"
                                    >
                                    </gofix-form-dropdown>
                                    <gofix-button class="ml-3" label="Create Frequency" @click="modals.frequency = true" noBorder fontNormal small></gofix-button>
                                </div>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input-number
                                        label="Tolerance Period"
                                        desc="Days"
                                        v-model="sorItem.tolerance_period"
                                        :integer-limit="3"
                                        :include-thousands-separator="false"
                                        :allowDecimal="false" ></gofix-form-input-number>
                            </b-col>
                            <b-col md="2">
                                <gofix-form-input-number
                                        label="Required Signatures"
                                        desc="Min. No. of required signatures"
                                        v-model="sorItem.number_of_required_signature"
                                        :integer-limit="3"
                                        :include-thousands-separator="false"
                                        :allowDecimal="false" >
                                    </gofix-form-input-number>
                                <!-- <b-form-checkbox v-model="sorItem.is_allow_signature" class="checkbox-main-allow"><span class="ml-2">Allow signature after complete job</span></b-form-checkbox> -->
                            </b-col>
                            <!-- <b-col md="4">
                                <b-form-checkbox v-model="sorItem.is_allow_time_manual" class="checkbox-main-allow"><span class="ml-2">Allow manual input for job's start-time and end-time</span></b-form-checkbox>
                            </b-col> -->
                            <b-col md="4">
                                <b-form-checkbox v-model="sorItem.is_allow_job_end" class="checkbox-main-allow"><span class="ml-2">Allow user to input Job End before completing the job</span></b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <gofix-form-input label="SOFT-FM Days Range Last Activity To Upcoming Activity" v-model="sorItem.last_activity_to_upcoming_activity"></gofix-form-input>
                            </b-col>
                            <b-col md="4"></b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_user_to_enter_timestamp_for_issue_action_taken" class="checkbox-main-allow"><span class="ml-2">Allow user to enter Timestamp for Issue.ActionTaken</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <div class="d-flex maintCreateFrequency">
                                    <gofix-form-dropdown
                                            label="Pre-condition checklist template"
                                            vLabel="name_checklist_templates"
                                            :clearable="false"
                                            :filterable="false"
                                            :required="true"
                                            :reduce="option => option.id"
                                            :append-to-body="true"
                                            v-model="sorItem.pre_condition_checklist_template_id"
                                            :options="checklistTemplates"
                                    >
                                    </gofix-form-dropdown>
                                    <gofix-button class="ml-3 text-left" label="Create New Checklist" @click="modals.checklist = true" noBorder fontNormal small></gofix-button>
                                </div>
                            </b-col>
                            <b-col md="4"></b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_pre_condition_checklist_mandatory_complete" class="checkbox-main-allow"><span class="ml-2">Pre-condition checklist mandatory complete</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mb-4">
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_auto_creating_cwo_from_jobs_issues" class="checkbox-main-allow"><span class="ml-2">Allow Auto Creating CWO From Job's Issues</span></b-form-checkbox>
                                </div>
                            </b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_auto_fill_checklist_mobile" class="checkbox-main-allow"><span class="ml-2">Mobile: Allow auto-fill checklist (checkbox type)</span></b-form-checkbox>
                                </div>
                            </b-col>
                            <b-col md="4">
                                <div class="d-flex">
                                    <b-form-checkbox v-model="sorItem.is_allow_uploading_photos_gallery_mobile" class="checkbox-main-allow"><span class="ml-2">Mobile: Allow Uploading Photos From Gallery</span></b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                    </gofix-card>

                    <gofix-card classContent="mb-0 mt-4">
                        <b-row>
                            <b-col md="3">
                                <gofix-form-input-number
                                        label="Unit Price"
                                        required
                                        v-model="sorItem.unit_price_tmp"
                                        prefix="$"></gofix-form-input-number>
                            </b-col>
                            <b-col md="3">
                                <gofix-form-input label="Unit of Measurement" v-model="sorItem.unit_of_measurement"></gofix-form-input>
                            </b-col>
                            <b-col md="6">
                                <div class="d-flex align-items-start mt-20">
                                    <gofix-button class="mr-2 flex-140" label="Add Preset Actions" @click="modalPresetActions" outline></gofix-button>
                                    <div class="min-width-0">
                                        <span>{{ sorItem.preset_actions && sorItem.preset_actions.length ? `(${sorItem.preset_actions.join(", ")})` : ''}}</span>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                      <b-row align-v="end">
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Making jobs expired - allowed states"
                              multiple
                              append-to-body
                              v-model="sorItem.auto_expried"
                              :options='["Pending","Planned","Due","Started"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Rescheduling of jobs - allowed states"
                              multiple
                              append-to-body
                              v-model="sorItem.allow_job_rescheduled"
                              :options='["Planned","Due", "Expired"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Editing of Issue - Allowed states"
                              multiple
                              append-to-body
                              v-model="sorItem.editing_of_issue"
                              :options='["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                      </b-row>
                      <b-row align-v="end">
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Editing of Checklist - Allowed states"
                              multiple
                              append-to-body
                              v-model="sorItem.editing_of_checklist"
                              :options='["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Editing of Job Data - Allowed states"
                              multiple
                              append-to-body
                              v-model="sorItem.editing_of_job_data"
                              :options='["Planned","Due","Started","Completed","Verified","Cancelled","Expired","End","Inactive"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Auto Renew Job Schedule"
                              multiple
                              append-to-body
                              v-model="sorItem.auto_renew_job"
                              :options='["Completed","Verified"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4">
                          <gofix-form-dropdown
                              label="Geo-Fencing-Applicable States"
                              multiple
                              append-to-body
                              v-model="sorItem.geo_fencing_applicable_states"
                              :options='["Started","Completed", "Verified"]'
                          >
                          </gofix-form-dropdown>
                        </b-col>
                      </b-row>
                    </gofix-card>
                </b-form>
                <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create Frequency" hide-footer :centered="true" ref="modal-Create" v-model="modals.frequency">
                    <b-form class="pb-20">
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-number
                                        label="Number"
                                        v-model="frequency.number"
                                        :include-thousands-separator="false"></gofix-form-input-number>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-dropdown
                                        label="Unit"
                                        vLabel="reference_value_text"
                                        :clearable="false"
                                        :filterable="false"
                                        :required="true"
                                        :reduce="option => option.reference_value_text"
                                        v-model="frequency.type_date"
                                        :options="frequencyUnits"
                                >
                                </gofix-form-dropdown>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="APPLY" @click="addFrequency" noBorder></gofix-button>
                    </b-button-group>
                </b-modal>
                <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create new checklist " hide-footer :centered="true" ref="modal-Create" v-model="modals.checklist">
                    <b-form class="pb-20">
                        <b-row>
                            <b-col md="12">
                                <gofix-form-dropdown
                                        label="Select Master Checklist Template "
                                        vLabel="name_checklist_templates"
                                        :clearable="false"
                                        :filterable="false"
                                        :required="true"
                                        :reduce="option => option.id"
                                        v-model="sorItem.checklist_template_id"
                                        :options="checklistTemplates"
                                        desc="Select master checklist template or create new checklist"
                                >
                                </gofix-form-dropdown>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="CREATE NEW CHECKLIST" class="text-light-back max-width-150" @click="createNewChecklist" noBorder dark></gofix-button>
                        <gofix-button label="APPLY" @click="modals.checklist = false" noBorder></gofix-button>
                    </b-button-group>
                </b-modal>
                <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Preset Actions" hide-footer :centered="true" ref="modal-Create" v-model="modals.presetActions">
                    <b-form class="pb-20" v-if="presetActionsTmp">
                        <gofix-form-input
                                v-for="(item,index) in presetActionsTmp" :key="index"
                                label="Value Item"
                                v-model="presetActionsTmp[index]">
                            <template #gofixInput:text:after-desc>
                                <button type="button" class="btn btnDeleteService btn-secondary" @click="presetActionsTmp.splice(index, 1)"><img src="img/close.png" alt="close"></button>
                            </template>
                        </gofix-form-input>
                        <div class="text-center"><gofix-button class="gofixButtonFix" label="ADD NEW PRESET ACTION +" @click="presetActionsTmp.push('')" outline></gofix-button></div>
                    </b-form>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="APPLY" @click="savePresetActions" noBorder></gofix-button>
                    </b-button-group>
                </b-modal>
                <b-modal :no-close-on-backdrop="true" id="modal-Remove" dialog-class="modal-confirm-update" hide-footer hide-header :centered="true" v-model="modals.confirmUpdate.open">
                    <div class="center px-4 pt-3 pb-4">
                        <h4 class="mb-2">Warning</h4>
                        <p class="mb-0">Related schedules and jobs maybe affected by this update!</p>
                    </div>
                     <b-button-group class="btn-group">
                        <b-button class="custom-btn" @click="updateItem(true)">
                            <b-spinner v-if="modals.confirmUpdate.loading.updateDelete" type="grow" small></b-spinner>
                            Update and delete all related schedules and jobs
                        </b-button>
                    </b-button-group>
                    <b-button-group class="btn-group">
                        <b-button class="custom-btn" @click="updateItem(false)">
                            <b-spinner v-if="modals.confirmUpdate.loading.update" type="grow" small></b-spinner>
                            Update only, no deletion
                        </b-button>
                    </b-button-group>
                    <b-button-group class="btn-group">
                        <b-button class="custom-btn" @click="modals.confirmUpdate.open = false">Cancel</b-button>
                    </b-button-group>
                </b-modal>
            </template>
            <template slot="gofixTab:maint_schedule">
                <detail-schedule ref="detailSchedule"></detail-schedule>
            </template>
            <template slot="gofixTab:equipment_schedule">
                <div class="assetManagement pt-0">
                    <detail-equipment-schedule></detail-equipment-schedule>
                </div>
            </template>
            <template slot="gofixTab:activity-log">
                <maint-activity ref="maintActivities" activityType="Maintenance Program" :activityId="$route.params.maintenance_id"></maint-activity>
            </template>

        </gofix-tab>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect'
    const DetailSchedule = () => import('./detail-schedule')
    const DetailEquipmentSchedule = () => import('./detail-equipment-schedule')
    const MaintActivities = () => import("../global/Activities")
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    export default {
        name: 'basicInfo',
        components: {
            "detail-schedule" : DetailSchedule,
            "detail-equipment-schedule" : DetailEquipmentSchedule,
            "maint-activity" : MaintActivities,
        },
        data () {
            return {
                queryParam: { id: this.$route.params.id },
                activeKey: 'basic_info',
                tabData:[
                    {
                        key: "basic_info",
                        title: "BASIC INFO",
                        active: true,
                    },
                    {
                        key: "maint_schedule",
                        title: "MAINT. SCHEDULE",
                        active: false,
                        disabled: this.$route.params.maintenance_id == 0
                    },
                    {
                        key: "equipment_schedule",
                        title: "EQUIPMENT SCHEDULE",
                        active: false,
                        disabled: this.$route.params.maintenance_id == 0
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false,
                        disabled: this.$route.params.maintenance_id == 0
                    },
                ],
                treeEquips: [],
                treeProperty: [],
                checklistTemplates: [],
                Validate: false,
                disabledTab: false,
                rootIds:{
                    contract_id : this.$route.params.id,
                    contract_term_id: null
                },
                loadings:{
                    service:false,
                    equipment:false,
                    property:false,
                },
                modals:{
                    frequency:false,
                    checklist:false,
                    presetActions: false,
                    confirmUpdate: {
                        open: false,
                        loading: {
                            update: false,
                            updateDelete: false
                        }
                    }
                },
                frequency:{
                    number: '',
                    type_date: 'D',
                },
                disabledJob: false,
                frequencyUnits:[],
                presetActionsTmp: [],
                isProcessingCallContractSelector: false,
            }
        },
        async created () {
            if(this.$route.query.hasOwnProperty('tab') && ['basic_info', 'maint_schedule', 'equipment_schedule', 'activity-log'].includes(this.$route.query.tab)) {
                this.activeKey = this.$route.query.tab;
            }
            //Set root ids
            if(this.ClientContractID && this.ClientContractID.contract_terms){
                this.rootIds.contract_term_id = this.ClientContractID.contract_terms[0].id
                this.rootIds.contract_id = this.ClientContractID.id
            }
            if(this.sorItem.id && this.$route.params.maintenance_id && this.sorItem.id == this.$route.params.maintenance_id){
                this.rootIds.contract_term_id = this.sorItem.contract_term_id
                this.rootIds.contract_id = this.sorItem.contract_term && this.sorItem.contract_term.contract_id ? this.sorItem.contract_term.contract_id : 0;
                this.callbackContractSelector()
            }
            //Check maintenance_id (maintenance_id = sor_id)
            if(this.$route.params.maintenance_id != 0 && this.sorItem.id != this.$route.params.maintenance_id){
                this.$store.dispatch("v2SorController/getItem",this.$route.params.maintenance_id)
                .then(response => {
                    if(response.data.data.code && response.data.data.code == 400) {
                        if(this.$route.params.id) {
                            return this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program`)
                        } else {
                            this.$router.push(`/v2/maintenance-program`)
                        }
                    }
                });
            }
            //Disable schedule tabs if create new
            if(this.$route.params.maintenance_id == 0){
                this.disabledTab = true;
            }

            //Load data from contract
            if(this.rootIds.contract_id){
                this.getEquipsType(0, this.rootIds.contract_id, 'all',true)
                this.loadServiceCategories(this.rootIds.contract_id);
                this.getProperty(0, this.rootIds.contract_id, true);
            }
            this.loadChecklistTemplate();
            this.loadSorRecurringModes();
            this.sorItem.unit_price_tmp = this.$accounting.formatMoney(this.sorItem.unit_price);
            this.getFrequencyUnit();
        },
        watch: {
            ClientContractID : function(val, old){
                if(this.$route.name && this.$route.name === 'maintenance-program-info-all') {
                    if(!val || (val && old && val.id && old.id && val.id !== old.id)){
                        return this.$router.push(`/v2/maintenance-program`)
                    }
                } else {
                    if(!val) {
                        return this.$router.push(`/v2/contract-client`)
                    }
                    if(val && old && val.id && old.id && val.id !== old.id){
                        return this.$router.push(`/v2/contract-client/${val.id}/maintenance-program`)
                    }
                }
            },
            "sorItem": function (val) {
                if(val.id){
                    this.rootIds.contract_term_id = val.contract_term.id;
                    this.rootIds.contract_id = val.contract_term.contract_id;
                    this.getEquipsType(0, this.rootIds.contract_id, 'all',true)
                    this.getProperty(0, this.rootIds.contract_id, true);
                    this.loadServiceCategories(this.rootIds.contract_id);
                    this.sorItem.unit_price_tmp = this.$accounting.formatMoney(this.sorItem.unit_price);
                    this.callbackContractSelector()
                }
            },
        },
        computed: {
            ...mapGetters({
                sorItem:  'v2SorController/sorItem',
                Services:  'v2SorController/serviceCategories',
                // ClientContractID: 'ContractController/ClientContractID',
                sorRecurringModes: 'SorRecurringModesController/sorRecurringModes',
            })
        },
        methods:{
            loadTab(tab) {
                if(this.$route.query.hasOwnProperty('tab') && this.$route.query.tab == 'maint_schedule') {
                    this.$router.replace({'query': null});
                }
            },
            createNewChecklist() {
                let id = this.rootIds.contract_id ? this.rootIds.contract_id : this.ClientContractID ? this.ClientContractID.id : 0
                this.$router.push(`/v2/contract-client/${id}/checklist-template`)
            },
            loadServiceCategories(id){
                this.loadings.service = true;
                this.$store.dispatch('v2SorController/getService', {
                    contract_id: id,
                    service_id: 0
                }).then(response => {
                    this.loadings.service = false;
                });
            },
            async getEquipsType(parent_id, contract_id, node_type,set = false) {
                this.loadings.equipment = true;
                let dataE = [];
                await global.axios(`api/equipment/tree-structure/${parent_id}`,
                    {
                        method: "GET",
                        params: {
                            contract_id: contract_id,
                            node_type: node_type
                        },
                        headers: { Accept: "application/json", }
                    })
                    .then(response => {
                        dataE = response.data.data;
                        this.loadings.equipment = false;
                    }).catch(error => {
                        this.loadings.equipment = false;
                    });
                if(set){
                    this.treeEquips = dataE;
                }else{
                    return dataE
                }
            },
            async getProperty(property_root_id, contract_id, set = false) {
                this.loadings.property = true;
                let dataE = [];
                await global.axios(`api/contracts/${contract_id}/tree-properties/${property_root_id}`,
                    {
                        method: "GET",
                        headers: { Accept: "application/json", }
                    })
                    .then(response => {
                        dataE = response.data.data;
                        this.loadings.property = false;
                    }).catch(error => {
                        this.loadings.property = false;
                    });
                if(set){
                    this.treeProperty = dataE;
                }else{
                    return dataE
                }
            },
            loadSorRecurringModes(){
                this.$store.dispatch('SorRecurringModesController/getListSorRecurringModes');
            },
            loadChecklistTemplate(){
                this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [ 1000, 1, {contract_id: this.rootIds.contract_id}  ])
                    .then(response => { this.checklistTemplates = response.data.data.items });
            },
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if(parentNode.isBatch){
                    this.$store.dispatch("v2SorController/getService",{
                        contract_id:this.$route.params.id,
                        service_id:parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback()
                    })
                }else{
                    parentNode.children = undefined;
                    callback()
                }
            },
            normalizerService(node) {
                if(node.data && !node.data.isBatch){
                    return {
                        children : undefined,
                        label: node.name
                    }
                }
                return {
                    label: node.name
                }
            },
            normalizerEquipment(node) {
                if(node.isBatch) {
                    return {
                        id: node.data.id,
                        label: node.data.name,
                        children: node.children
                    }
                }
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                }
            },
            loadOptionsEquiment({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getEquipsType(parentNode.data.id, this.$route.params.id, 'all')
                        callback()
                    })
                }
            },
            updateItemQuestion(){
                this.sorItem.is_maintenance = true;
                if(!this.sorItem.sor_code
                    || !this.sorItem.service_category
                    || !this.sorItem.sor_recurring_mode_id
                    || !this.sorItem.checklist_template_id
                    || !this.sorItem.location_info
                ) {
                    this.$alertNotification("Please enter in all the fields", "danger");
                    this.Validate = true;
                    return false;
                }
                if(this.sorItem.id){
                    this.modals.confirmUpdate.open = true;
                }else{
                    this.updateItem();
                }
            },
            updateItem(is_delete_schedule_job = false){
                this.sorItem.is_delete_schedule_job = is_delete_schedule_job;
                if(is_delete_schedule_job) {
                    this.modals.confirmUpdate.loading.updateDelete = true
                } else {
                    this.modals.confirmUpdate.loading.update = true;
                }

                this.sorItem.unit_price = this.$accounting.unformat(this.sorItem.unit_price_tmp);
                let contract_term_id = this.rootIds.contract_term_id || 0;
                this.$store.dispatch("v2SorController/saveSorItem",contract_term_id)
                    .then( data => {
                        this.modals.confirmUpdate.loading.updateDelete = false
                        this.modals.confirmUpdate.loading.update = false;
                        this.modals.confirmUpdate.open = false;
                        this.$alertNotification(this.$notificationV2('editing', 'maintenance_program'));
                        if(this.$route.params.maintenance_id == 0){
                            this.disabledTab = false;
                            this.$store.dispatch("v2SorController/getItem",data.id);
                            this.sorItem.unit_price_tmp = this.$accounting.formatMoney(data.unit_price);
                            this.tabData.map(item => {
                                item.disabled = this.disabledTab;
                                return item;
                            })
                            return this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program/${data.id}`);
                        }
                    })
                    .catch(err => {
                        this.modals.confirmUpdate.loading.updateDelete = false
                        this.modals.confirmUpdate.loading.update = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    });
            },
            addFrequency() {
                this.$store.dispatch('SorRecurringModesController/createSorRecurringModes',this.frequency)
                    .then(result => {
                        this.sorItem.sor_recurring_mode_id = result.data.data.id;
                        this.modals.frequency = false
                        return this.$alertNotification(this.$notificationV2('adding', 'frequency'));
                    })
                    .catch(error => {
                        if(error.response) {
                            if(error.response.data.error.message.number)
                                return this.$alertNotification(error.response.data.error.message.number[0], "danger");
                            if(error.response.data.error.message.recurring_mode)
                                return this.$alertNotification("Frequency already exist", "danger");
                            return this.$alertNotification("Error", "danger");
                        }
                    })
            },
            async modalsRunsheet(){
                if(this.sorItem.location_info && !this.sorItem.location_info.is_active) {
                    return this.$alertNotification("The property is inactive so job creation cannot be created", "danger");
                }
                this.disabledJob = true;
                await this.$refs.detailSchedule.modalsRunsheet()
                this.disabledJob = false;
            },
            getFrequencyUnit(){
                let filter = {reference_type: "Frequency Unit"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.frequencyUnits = response.items;
                })
            },
            modalPresetActions() {
                this.presetActionsTmp = JSON.parse(JSON.stringify(this.sorItem.preset_actions));
                if(!this.presetActionsTmp.length)
                    this.presetActionsTmp.push('');
                this.modals.presetActions = true;
            },
            savePresetActions() {
                if(this.presetActionsTmp) {
                    let filter = this.presetActionsTmp.filter(item => !item)
                    if(filter.length) {
                        return this.$alertNotification("Please fill in values for all items", "danger");
                    }
                    this.sorItem.preset_actions = JSON.parse(JSON.stringify(this.presetActionsTmp));
                }
                this.modals.presetActions = false;
            },
            // callback Contract selector
            callbackContractSelector() {
                if(this.isProcessingCallContractSelector) return
                if(
                    (this.sorItem && this.sorItem.contract_term && this.sorItem.contract_term.contract_id) &&
                    (!this.clientContractID || !this.clientContractID.id || (this.clientContractID && this.clientContractID.id && this.clientContractID.id != val.client_contract_id))
                ) {
                    this.isProcessingCallContractSelector = true;
                    this.$store.dispatch( 'ContractController/getClientContractID', this.sorItem.contract_term.contract_id).then(response => {
                        this.isProcessingCallContractSelector = false;
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    }).catch(error => {
                        this.isProcessingCallContractSelector = false;
                    });
                }
                
            }
        },
    }
</script>
